declare const SiteIDSymbol: unique symbol
export type SiteID = string & { [SiteIDSymbol]: never }

export interface CustomFieldDefinitionDto {
    id: string
    field_name: string
    label: string
    model_type: string
    type: string
    hospital_id: string
    required: boolean
}

export interface CustomFieldDefinition {
    id: string
    fieldName: string
    label: string
    modelType: string
    type: string
    hospitalId: string
    required: boolean
}

export const createCustomFieldDefinition = (
    params: {
        id: string
        fieldName: string
        label: string
        modelType: string
        type: string
        hospitalId: string
        required: boolean
    }
): CustomFieldDefinition => ({
    id: params.id,
    fieldName: params.fieldName,
    label: params.label,
    modelType: params.modelType,
    type: params.type,
    hospitalId: params.hospitalId,
    required: params.required
})

export const customFieldDefinitionFromDto = (dto: CustomFieldDefinitionDto): CustomFieldDefinition => (createCustomFieldDefinition({
    id: dto.id,
    fieldName: dto.field_name,
    label: dto.label,
    modelType: dto.model_type,
    type: dto.type,
    hospitalId: dto.hospital_id,
    required: dto.required
}))

export interface SiteJson {
    id: string
    name: string
    permissions: {
        buildings: { can_create: boolean }
        groups: { can_create: boolean }
        reasons: { can_create: boolean }
        skills: { can_create: boolean }
        shifts: { can_manage: boolean }
    }
    custom_field_definitions?: {
        data: CustomFieldDefinitionDto[]
    }
}

export class Site {
    id: SiteID
    name: string
    permissions: {
        buildings: { canCreate: boolean }
        groups: { canCreate: boolean }
        reasons: { canCreate: boolean }
        skills: { canCreate: boolean }
        shifts: { canManage: boolean }
    }
    customFieldDefinitions: CustomFieldDefinition[]

    constructor(
        id: string,
        name: string,
        permissions: {
            buildings: { canCreate: boolean },
            groups: { canCreate: boolean },
            reasons: { canCreate: boolean },
            skills: { canCreate: boolean },
            shifts: { canManage: boolean },
        },
        customFieldDefinitions: CustomFieldDefinition[] = []
    ) {
        this.id = id as SiteID
        this.name = name
        this.permissions = permissions
        this.customFieldDefinitions = customFieldDefinitions
    }

    static fromJson(json: SiteJson): Site {
        return new Site(
            json.id,
            json.name,
            {
                buildings: { canCreate: json.permissions.buildings.can_create },
                groups: { canCreate: json.permissions.groups.can_create },
                reasons: { canCreate: json.permissions.reasons.can_create },
                skills: { canCreate: json.permissions.skills.can_create },
                shifts: { canManage: json.permissions.shifts.can_manage },
            },
            json.custom_field_definitions?.data.map(customFieldDefinitionFromDto) ?? []
        )
    }
}
